import React from 'react';
import { makeStyles } from 'design-system/styles';
import { Button, Paper } from 'react-scale/components/design-system';

interface INERLinkingModeHeaderProps {
  onExitLinkingMode: () => void;
}

const NERLinkingModeHeader: React.FC<INERLinkingModeHeaderProps> = ({ onExitLinkingMode }) => {
  const classes = useNERLinkingModeHeader();
  return (
    <Paper className={classes.header}>
      <span className={classes.headerText}>Click on labels to link them</span>
      <Button type={'primary'} onClick={onExitLinkingMode}>
        Done
      </Button>
    </Paper>
  );
};

const useNERLinkingModeHeader = makeStyles({
  header: {
    position: 'fixed',
    left: '50%',
    transform: 'translate(-50%, -50px)',
    width: 'fit-content',
    padding: 8,
    background: '#404040',
    zIndex: 3,
  },

  headerText: {
    fontSize: 14,
    lineHeight: '20px',
    color: '#ccc',
    marginInlineEnd: '12px',
  },
});

export default NERLinkingModeHeader;
